export default __webpack_public_path__ + "static/media/pcp-guide-chart-3.cf484e65.svg";